import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Text, Toast, useToast } from '@zillow/constellation';

export const enqueuedToast = (
  <Toast id="zon_NotificationSuccess" appearance="success" body={<Text>Zillow applications enabled.</Text>} />
);

function EnrollSuccessToast({ enrollmentOn }) {
  const { enqueueToast } = useToast();
  const [canToastShow, setCanToastShow] = useState(false);

  useEffect(() => {
    // Prevent toast from showing upon mount.
    if (enrollmentOn === false) {
      setCanToastShow(true);
    }

    if (enrollmentOn && canToastShow) {
      enqueueToast(enqueuedToast);
    }
  }, [canToastShow, enrollmentOn, enqueueToast]);

  return null;
}

EnrollSuccessToast.propTypes = {
  enrollmentOn: PropTypes.bool,
};

export default EnrollSuccessToast;
